import { cn } from '@/lib/cn';

export function Loader({ className }: { className?: string }) {
  return (
    <div className={cn('flex h-full w-full items-center justify-center py-12', className)}>
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-hint border-t-button" />
    </div>
  );
}
